import Vue from 'vue';
import Router from 'vue-router';

//前端界面
const Layout = () => import('@/pages/layout/layout.vue');
const Home = () => import('@/pages/index/index.vue');
const Center = () => import('@/pages/index/center.vue');
const Guide = () => import('@/pages/index/guide.vue');
const Policy = () => import('@/pages/index/policy.vue');
const Party = () => import('@/pages/index/party.vue');
const News = () => import('@/pages/index/news.vue');
const Exam = () => import('@/pages/index/exam.vue');
const Practice = () => import('@/pages/index/practice.vue');
const Certificate = () => import('@/pages/index/certificate.vue');
const Recruit = () => import('@/pages/index/recruit.vue');
const Download = () => import('@/pages/index/download.vue');
const TrainNews = () => import('@/pages/index/train_news.vue');
const ArticleDetails = () => import('@/pages/index/article_details');
const ArticlePreview = () => import('@/pages/index/article_preview');
const recruitDetails = () => import('@/pages/index/recruit_details');
const Course = () => import('@/pages/index/course');
const CourseInfo = () => import('@/pages/index/course_info');
const CourseInfo2 = () => import('@/pages/index/course_info2');
const AboutUs = () => import('@/pages/index/about_us');
const process = () => import('@/pages/index/process');

const Faq = () => import('@/pages/index/faq');
const CoursePreview = () => import('@/pages/index/course_preview');
const VideoInfo = () => import('@/pages/index/video_info');

// 登录注册
// const Login = () => import('@/pages/login/login.vue');
// const Reg = () => import('@/pages/login/reg.vue');
// const Reg2 = () => import('@/pages/login/reg2.vue');
// const Reg3 = () => import('@/pages/login/reg3.vue');
// const Reg4 = () => import('@/pages/login/reg4.vue');
// const Forget = () => import('@/pages/login/forget.vue');
//用户后台
const User = () => import('@/pages/layout/user.vue');
const uHome = () => import('@/pages/user/index.vue');
const uNews = () => import('@/pages/user/news.vue');
const uFaq = () => import('@/pages/user/faq.vue');
const uFaqInfo = () => import('@/pages/user/faq_info.vue');
const uCourse = () => import('@/pages/user/course.vue');
const uCourseInfo = () => import('@/pages/user/course_info.vue');
const uCourseInfo2 = () => import('@/pages/user/course_info2.vue');
const uOrder = () => import('@/pages/user/order');
const uOrderInfo = () => import('@/pages/user/order_info.vue');
const uPaySuc = () => import('@/pages/user/pay_suc.vue');
const uTrain = () => import('@/pages/user/train.vue');
const uTrainAll = () => import('@/pages/user/train_all.vue');
const uTrainInfo = () => import('@/pages/user/train_info.vue');
const uTrainLine = () => import('@/pages/user/train_line.vue');
const uTrainFace = () => import('@/pages/user/train_face');
const uTrainMakeup = () => import('@/pages/user/train_makeup');
const uTrainLog = () => import('@/pages/user/train_log');
const uPayMakeup = () => import('@/pages/user/pay_makeup');
const uTrainFree = () => import('@/pages/user/train_free');
const uInfo = () => import('@/pages/user/user_info');
const uInvoiceAdd = () => import('@/pages/user/invoice_add');
const uInvoiceEdit = () => import('@/pages/user/invoice_edit');
const uInvoice = () => import('@/pages/user/invoice');
const uInvoiceInfo = () => import('@/pages/user/invoice_info');
const uJob = () => import('@/pages/user/job');
const uJobForm = () => import('@/pages/user/job_form');
const uVideo = () => import('@/pages/user/video.vue');
const uReview = () => import('@/pages/user/review.vue');
const uReviewInfo = () => import('@/pages/user/review_info.vue');
const uReviewReciteInfo = () => import('@/pages/user/review_recite_info');
const uWrongInfo = () => import('@/pages/user/wrong_info');
const uExamInfo = () => import('@/pages/user/exam_info.vue');
const uOfflinePay = () => import('@/pages/user/offline_pay.vue');
const uMail = () => import('@/pages/user/mail.vue');
const uMailForm = () => import('@/pages/user/mail_form.vue');

const uCertificate = () => import('@/pages/user/certificate.vue');

const uCar = () => import('@/pages/user/car.vue');
const uCarPay = () => import('@/pages/user/car_pay.vue');



//企业
// const Company = () => import('@/pages/layout/company.vue');
// const cHome = () => import('@/pages/company/index.vue');
// const cNews = () => import('@/pages/company/news.vue');
// const cFaq = () => import('@/pages/company/faq.vue');
// const cFaqInfo = () => import('@/pages/company/faq_info.vue');
// const cCourse = () => import('@/pages/company/course.vue');
// const cCourseInfo = () => import('@/pages/company/course_info.vue');
// const cCourseInfo2 = () => import('@/pages/company/course_info2.vue');
// const cApplicant = () => import('@/pages/company/applicant.vue');
// const cPay = () => import('@/pages/company/pay.vue');
// const cPaySuc = () => import('@/pages/company/pay_suc.vue');
// const cCourseAdmin = () => import('@/pages/company/course_admin.vue');
// const cCourseNum = () => import('@/pages/company/course_num.vue');
// const cCoursePaynum = () => import('@/pages/company/course_paynum.vue');
// const cCourseUnpaid = () => import('@/pages/company/course_unpaid.vue');
// const cCourseStudy = () => import('@/pages/company/course_study.vue');
// const cTrain = () => import('@/pages/company/train.vue');
// const cTrainList = () => import('@/pages/company/train_list.vue');
// const cMakeup = () => import('@/pages/company/makeup.vue');
// const cMakeupNum = () => import('@/pages/company/makeup_num.vue');
// const cMakeupUnpaid = () => import('@/pages/company/makeup_unpaid.vue');
// const cPayMakeup = () => import('@/pages/company/pay_makeup.vue');
// const cMakeupPaynum = () => import('@/pages/company/makeup_paynum.vue');
// const cMakeupClass = () => import('@/pages/company/makeup_class.vue');
// const cMakeupUnClass = () => import('@/pages/company/makeup_unclass.vue');
// const cStaff = () => import('@/pages/company/staff.vue');
// const cInfo = () => import('@/pages/company/company_info.vue');
// const cInvoiceAdd = () => import('@/pages/company/invoice_add.vue');
// const cInvoiceEdit = () => import('@/pages/company/invoice_edit.vue');
// const cInvoice = () => import('@/pages/company/invoice.vue');
// const cInvoiceInfo = () => import('@/pages/company/invoice_info.vue');
// const cJob= () => import('@/pages/company/job.vue');
// const cJobForm= () => import('@/pages/company/job_form.vue');
// const cCertificate= () => import('@/pages/company/certificate.vue');
// const cCertificateList= () => import('@/pages/company/certificate_list.vue');
// const cOrder= () => import('@/pages/company/order');

Vue.use(Router);
export default new Router({
     // mode: 'history',
    routes: [{
            path: '/',
            name: 'layout',
            component: Layout,
            redirect: '/index',
            // redirect: '',
            meta: {},
            children: [{
                    path: 'index',
                    // path: '',
                    name:'index',
                    component: Home,
                    meta:{
                        navIndex:0,
                        name:'首页',
                    }
                },
				{
				    path: '/video_info/:id',
				    name: 'VideoInfo',
				    component: VideoInfo,
				    meta: {
				        name:'课程视频'
				    },
				},
                {
                    path: 'center',
                    name:'center',
                    component: Center,
                    meta:{
                        navIndex:1,
                        name:'中心机构',
                        record:1,
                    }
                },
                {
                    path: 'guide',
                    name:'guide',
                    component: Guide,
                    meta:{
                        navIndex:2,
                        name:'办事指南',
                        record:1,
                    }
                },
                {
                    path: 'policy',
                    name:'policy',
                    component: Policy,
                    meta:{
                        navIndex:3,
                         name:'政策法规',
                        record:1,
                    }
                },
                {
                    path: 'party',
                    name:'party',
                    component: Party,
                    meta:{
                        navIndex:4,
                         name:'党建之窗',
                        record:1,
                    }
                },
                {
                    path: 'news',
                    name:'news',
                    component: News,
                    meta:{
                        navIndex:5,
                        record:1,
                         name:'动态信息',
                    }
                },
                {
                    path: 'exae',
                    name:'exae',
                    component: Exam,
                    meta:{
                        navIndex:6,
                        record:1,
                        name:'考试考务',
                    }
                },
                {
                    path: 'practice',
                    name:'practice',
                    component: Practice,
                    meta:{
                        navIndex:7,
                        record:1,
                        name:'执业注册',
                    }
                },
                {
                    path: 'train_news',
                    name:'train_news',
                    component: TrainNews,
                    meta:{
                        navIndex:8,
                        record:1,
                         name:'培训教育',
                    }
                },
                {
                    path: 'course',
                    name:'course',
                    component: Course,
                    meta:{
                         navIndex:8,
                        record:1,
                         name:'培训课程',
                    }
                },
                {
                    path: 'course_info/:id',
                    name:'course_info',
                    component: CourseInfo,
                    meta:{
                         navIndex:8,
                        record:1,
                          name:'培训课程',
                    }
                },
				{
				    path: 'course_info2/:id',
				    name:'course_info2',
				    component: CourseInfo2,
				    meta:{
				         navIndex:8,
				        record:1,
				          name:'培训课程',
				    }
				},
                {
                    path: 'faq',
                    name:'faq',
                    component: Faq,
                    meta:{
                        record:1,
                          name:'常见问题',
                    }
                },
				{
				    path: 'aboutus',
				    name:'aboutus',
				    component: AboutUs,
				    meta:{
					  name:'企业介绍',
				    }
				},
				{
				    path: 'process',
				    name:'process',
				    component: process,
				    meta:{
					  name:'操作流程',
				    }
				},
                {
                    path: 'certificate',
                    name:'certificate',
                    component: Certificate,
                    meta:{
                        navIndex:9,
                         name:'证书查询',
                    }
                },
				
                {
                    path: 'download',
                    name:'download',
                    component: Download,
                    meta:{
                        navIndex:11,
                        record:1,
                         name:'下载中心',
                    }
                },
                {
                    path: 'article_details/:id',
                    name:'article_details',
                    component: ArticleDetails,
                    meta:{
                         name:'文章详情'
                    }
                },
                {
                    path: 'recruit_details/:id',
                    name:'recruit_details',
                    component: recruitDetails,
                    meta:{
                         name:'招聘详情'
                    }
                },
            ]
        },
        {
            path: '/user',
            name: 'user',
            component: User,
            redirect: '/user/index',
            meta: {},
            children: [{
                path: 'index',
                name:'userIndex',
                component: uHome,
                meta:{
                    hideNav:false,
                    index:0,
                    name:'个人中心',
                    role: ['user'],
                }
            },
			{
			      path: '/video/:id',
			      name:'userVideo',
			      component: uVideo,
			      meta:{
			          name:'课程视频',
			          role: ['user']
			      }
			  },
			  {
			      path: '/review_info/:id/:cid/:is_ks',
			      name:'userReviewInfo',
			      component: uReviewInfo,
			      meta:{
			          name:'复习题',
			          role: ['user']
			      }
			  },
					{
					    path: '/review_recite_info/:id/:cid',
					    name:'uReviewReciteInfo',
					    component: uReviewReciteInfo,
					    meta:{
					        name:'背题模式',
					        role: ['user']
					    }
					},
					{
					    path: '/wrong_info/:id/:cid',
					    name:'uWrongInfo',
					    component: uWrongInfo,
					    meta:{
					        name:'错题库',
					        role: ['user']
					    }
					},
					
			  {
			      path: '/exam_info/:id',
			      name:'userExamInfo',
			      component: uExamInfo,
			      meta:{
			          name:'考试',
			          role: ['user']
			      }
			  },
			
			{
                path: 'news',
                name:'userNews',
                component: uNews,
                meta:{
                    hideNav:false,
                    index:0,
                    name:'全部消息',
                    role: ['user']
                }
            },
            {
                path: 'faq',
                name:'userFaq',
                component: uFaq,
                meta:{
                    hideNav:false,
                    index:0,
                    name:'常见问题',
                    role: ['user']
                }
            },
            {
                path: 'faq_info/:id',
                name:'userFaqInfo',
                component: uFaqInfo,
                meta:{
                    hideNav:false,
                    index:0,
                    name:'常见问题',
                    role: ['user']
                }
            },
            {
                path: 'course',
                name:'userCourse',
                component: uCourse,
                meta:{
                    hideNav:false,
                    index:1,
                    name:'课程中心',
                    role: ['user']
                }
            },{
                path: 'course_info/:id',
                name:'userCourseInfo',
                component: uCourseInfo,
                meta:{
                    hideNav:false,
                    index:1,
                    name:'课程中心',
                    role: ['user']
                }
            },
			{
			    path: 'course_info2/:id',
			    name:'userCourseInfo2',
			    component: uCourseInfo2,
			    meta:{
			        hideNav:false,
			        index:1,
			        name:'课程中心',
			        role: ['user']
			    }
			},
            {
                path: 'order/:id',
                name:'userOrder',
                component: uOrder,
                meta:{
                    hideNav:false,
                    index:2,
                    name:'订单管理',
                    role: ['user']
                }
            },
            {
                path: 'order_info/:id',
                name:'userOrderInfo',
                component: uOrderInfo,
                meta:{
                    hideNav:false,
                    index:2,
                    name:'订单详情',
                    role: ['user']
                }
            },
            {
                path: 'offline_pay/:id',
                name:'userOfflinePay',
                component: uOfflinePay,
                meta:{
                    hideNav:false,
                    index:2,
                    name:'线下转账',
                    role: ['user']
                }
            },
            {
                path: 'pay_suc/:id',
                name:'userPaySuc',
                component: uPaySuc,
                meta:{
                    hideNav:false,
                    index:2,
                    name:'缴费成功',
                    role: ['user']
                }
            },
            
            {
                path: 'train_all',
                name:'userTrainAll',
                component: uTrainAll,
                meta:{
                    hideNav:false,
                    index:3,
                    subIndex:0,
                    name:'全部课程',
                    role: ['user'],
                    record:1,
                }
            },
            {
                path: 'train',
                name:'userTrain',
                component: uTrain,
                meta:{
                    hideNav:false,
                    index:3,
                    subIndex:1,
                    name:'网授课程表',
                    role: ['user'],
                    record:1,
                }
            },
            {
                path: 'train_info/:id',
                name:'userTrainInfo',
                component: uTrainInfo,
                meta:{
                    hideNav:false,
                    index:3,
                    subIndex:2,
                    name:'课程详情',
                    role: ['user']
                }
            },
            {
                path: 'train_line',
                name:'userTrainLine',
                component: uTrainLine,
                meta:{
                    hideNav:false,
                    index:3,
                    subIndex:3,
                    name:'网授线下课程表',
                    role: ['user'],
                    record:1,
                }
            },
            {
                path: 'train_face',
                name:'userTrainFace',
                component: uTrainFace,
                meta:{
                    hideNav:false,
                    index:3,
                    subIndex:4,
                    name:'面授课程表',
                    role: ['user'],
                    record:1,
                }
            },
            {
                path: 'train_makeup',
                name:'userTrainMakeup',
                component: uTrainMakeup,
                meta:{
                    hideNav:false,
                    index:3,
                    subIndex:5,
                    name:'我的补考',
                    role: ['user'],
                    record:1,
                }
            },
            {
                path: 'train_log',
                name:'userTrainLog',
                component: uTrainLog,
                meta:{
                    hideNav:false,
                    index:7,
                    subIndex:6,
                    name:'培训记录',
                    role: ['user'],
                    record:1,
                }
            },
            
            {
                path: 'pay_makeup',
                name:'userPayMakeup',
                component: uPayMakeup,
                meta:{
                    hideNav:false,
                    index:3,
                    subIndex:3,
                    name:'支付补考费用',
                    role: ['user']
                }
            },
            {
                path: 'train_free',
                name:'userTrainFree',
                component: uTrainFree,
                meta:{
                    hideNav:false,
                    index:3,
                    subIndex:4,
                    name:'公益课程表',
                    role: ['user'],
                    record:1,
                }
            },
            {
                path: 'review/:id/:type',
                name:'userReview',
                component: uReview,
                meta:{
                    hideNav:false,
                    index:3,
                    subIndex:0,
                    name:'复习题',
                    role: ['user']
                }
            },
            {
                path: 'user_info',
                name:'userInfo',
                component: uInfo,
                meta:{
                    hideNav:false,
                    index:4,
                    name:'学员信息',
                    role: ['user']
                }
            },
            {
                path: 'invoice_add',
                name:'userInvoiceAdd',
                component: uInvoiceAdd,
                meta:{
                    hideNav:false,
                    index:4,
                    name:'新增发票',
                    role: ['user']
                }
            },
            {
                path: 'invoice_edit/:id',
                name:'userInvoiceEdit',
                component: uInvoiceEdit,
                meta:{
                    hideNav:false,
                    index:4,
                    name:'编辑发票',
                    role: ['user']
                }
            },
            {
                path: 'invoice',
                name:'userInvoice',
                component: uInvoice,
                meta:{
                    hideNav:false,
                    index:5,
                    name:'发票管理',
                    role: ['user']
                }
            },
            {
                path: 'invoice_info/:id',
                name:'userInvoiceInfo',
                component: uInvoiceInfo,
                meta:{
                    hideNav:false,
                    index:5,
                    name:'发票管理',
                    role: ['user']
                }
            },
			{
			    path: 'mail',
			    name:'userMail',
			    component: uMail,
			    meta:{
			        hideNav:false,
			        index:8,
			        name:'邮寄服务',
			        role: ['user']
			    }
			},
			{
			    path: 'mail_form/:id',
			    name:'userMailForm',
			    component: uMailForm,
			    meta:{
			        hideNav:false,
			        index:8,
			        name:'邮寄服务',
			        role: ['user']
			    }
			},
			{
			    path: 'certificate',
			    name:'userCertificate',
			    component: uCertificate,
			    meta:{
			        hideNav:false,
			        index:9,
			        name:'证书管理',
			        role: ['user']
			    }
			},
			{
			    path: 'car',
			    name:'uCar',
			    component: uCar,
			    meta:{
			        hideNav:false,
			        index:10,
			        name:'购物车',
			        role: ['user']
			    }
			},
			{
			    path: 'car_pay/:id',
			    name:'uCarPay',
			    component: uCarPay,
			    meta:{
			        hideNav:false,
			        index:10,
			        name:'购物车',
			        role: ['user']
			    }
			},
            {
                path: 'job',
                name:'uuserJob',
                component: uJob,
                meta:{
                    hideNav:false,
                    index:6,
                    name:'求职信息',
                    role: ['user']
                }
            },
            {
                path: 'job_form/:id',
                name:'uuserJobForm',
                component: uJobForm,
                meta:{
                    hideNav:false,
                    index:6,
                    name:'求职信息',
                    role: ['user']
                }
            },
         ]},
    //   {
    //       path: '/company',
    //       name: 'company',
    //       component: Company,
    //       redirect: '/company/index',
    //       meta: {},
    //       children: [{
    //           path: 'index',
    //           name:'companyIndex',
    //           component: cHome,
    //           meta:{
    //               hideNav:false,
    //               index:0,
    //               name:'企业中心',
    //               role: ['company']
    //           }
    //       },{
    //           path: 'news',
    //           name:'companyNews',
    //           component: cNews,
    //           meta:{
    //               hideNav:false,
    //               index:0,
    //               name:'消息中心',
    //               role: ['company']
    //           }
    //       },
		  
		  // {
		  //     path: 'order/:id',
		  //     name:'companyOrder',
		  //     component: cOrder,
		  //     meta:{
		  //         hideNav:false,
		  //         index:11,
		  //         name:'订单管理',
		  //         role: ['company']
		  //     }
		  // },
		  
		  
		  // {
    //           path: 'course',
    //           name:'companyCourse',
    //           component: cCourse,
    //           meta:{
    //               hideNav:false,
    //               index:1,
    //               name:'课程中心',
    //               role: ['company']
    //           }
    //       },{
    //           path: 'course_info/:id',
    //           name:'companyCourseInfo',
    //           component: cCourseInfo,
    //           meta:{
    //               hideNav:false,
    //               index:1,
    //               name:'课程中心',
    //               role: ['company']
    //           }
    //       },
		  // {
		  //     path: 'course_info2/:id',
		  //     name:'companyCourseInfo2',
		  //     component: cCourseInfo2,
		  //     meta:{
		  //         hideNav:false,
		  //         index:1,
		  //         name:'课程中心',
		  //         role: ['company']
		  //     }
		  // },
    //       {
    //           path: 'faq',
    //           name:'companyFaq',
    //           component: cFaq,
    //           meta:{
    //               hideNav:false,
    //               index:0,
    //               name:'常见问题',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'faq_info/:id',
    //           name:'companyFaqInfo',
    //           component: cFaqInfo,
    //           meta:{
    //               hideNav:false,
    //               index:0,
    //               name:'常见问题',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'applicant/:id',
    //           name:'companyApplicant',
    //           component: cApplicant,
    //           meta:{
    //               hideNav:false,
    //               index:1,
    //               name:'选择报名人',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'pay/:id',
    //           name:'companyPay',
    //           component: cPay,
    //           meta:{
    //               hideNav:false,
    //               index:1,
    //               name:'提交缴费',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'pay_suc/:id',
    //           name:'companyPaySuc',
    //           component: cPaySuc,
    //           meta:{
    //               hideNav:false,
    //               index:1,
    //               name:'提交缴费',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'course_admin',
    //           name:'companyCourseAdmin',
    //           component: cCourseAdmin,
    //           meta:{
    //               hideNav:false,
    //               index:2,
    //               name:'课程管理',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'course_num/:id',
    //           name:'companyCourseNum',
    //           component: cCourseNum,
    //           meta:{
    //               hideNav:false,
    //               index:2,
    //               name:'报名人数',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'course_paynum/:id',
    //           name:'companyCoursePaynum',
    //           component: cCoursePaynum,
    //           meta:{
    //               hideNav:false,
    //               index:2,
    //               name:'已缴费人数',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'course_unpaid/:id',
    //           name:'companyCourseUnpaid',
    //           component: cCourseUnpaid,
    //           meta:{
    //               hideNav:false,
    //               index:2,
    //               name:'未缴费人数',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'course_study',
    //           name:'companyCourseStudy',
    //           component: cCourseStudy,
    //           meta:{
    //               hideNav:false,
    //               index:2,
    //               name:'学习课程',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'train',
    //           name:'companyTrain',
    //           component: cTrain,
    //           meta:{
    //               hideNav:false,
    //               index:3,
    //               name:'培训记录',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'train_list/:id',
    //           name:'companyTrainList',
    //           component: cTrainList,
    //           meta:{
    //               hideNav:false,
    //               index:3,
    //               name:'员工信息',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'makeup',
    //           name:'companyMakeup',
    //           component: cMakeup,
    //           meta:{
    //               hideNav:false,
    //               index:4,
    //               name:'补考管理',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'makeup_num/:id',
    //           name:'companyMakeupNum',
    //           component: cMakeupNum,
    //           meta:{
    //               hideNav:false,
    //               index:4,
    //               name:'补考员工',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'makeup_unpaid/:id',
    //           name:'companyMakeupUnpaid',
    //           component: cMakeupUnpaid,
    //           meta:{
    //               hideNav:false,
    //               index:4,
    //               name:'未缴费人数',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'pay_makeup/:id',
    //           name:'companyPayMakeup',
    //           component: cPayMakeup,
    //           meta:{
    //               hideNav:false,
    //               index:4,
    //               name:'批量缴费',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'makeup_paynum/:id',
    //           name:'companyPaynum',
    //           component: cMakeupPaynum,
    //           meta:{
    //               hideNav:false,
    //               index:4,
    //               name:'已缴费人数',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'makeup_class/:id',
    //           name:'companyClass',
    //           component: cMakeupClass,
    //           meta:{
    //               hideNav:false,
    //               index:4,
    //               name:'已分班',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'makeup_unclass/:id',
    //           name:'companyUnClass',
    //           component: cMakeupUnClass,
    //           meta:{
    //               hideNav:false,
    //               index:4,
    //               name:'未分班',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'staff',
    //           name:'companyStaff',
    //           component: cStaff,
    //           meta:{
    //               hideNav:false,
    //               index:5,
    //               name:'员工管理',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'info',
    //           name:'companyInfo',
    //           component: cInfo,
    //           meta:{
    //               hideNav:false,
    //               index:6,
    //               name:'企业信息',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'invoice_add',
    //           name:'companyInvoiceAdd',
    //           component: cInvoiceAdd,
    //           meta:{
    //               hideNav:false,
    //               index:6,
    //               name:'添加发票',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'invoice_edit/:id',
    //           name:'companyInvoiceEdit',
    //           component: cInvoiceEdit,
    //           meta:{
    //               hideNav:false,
    //               index:6,
    //               name:'编辑发票',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'invoice',
    //           name:'companyInvoice',
    //           component: cInvoice,
    //           meta:{
    //               hideNav:false,
    //               index:8,
    //               name:'发票管理',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'invoice_info/:id',
    //           name:'companyInvoiceInfo',
    //           component: cInvoiceInfo,
    //           meta:{
    //               hideNav:false,
    //               index:8,
    //               name:'发票详情',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'job',
    //           name:'companyJob',
    //           component: cJob,
    //           meta:{
    //               hideNav:false,
    //               index:7,
    //               name:'企业招聘',
    //               role: ['company']
    //           }
    //       },
    //       {
    //           path: 'job_form/:id',
    //           name:'companyJobForm',
    //           component: cJobForm,
    //           meta:{
    //               hideNav:false,
    //               index:7,
    //               name:'企业招聘',
    //               role: ['company']
    //           }
    //       },
		  // {
		  //     path: 'certificate',
		  //     name:'companyCertificate',
		  //     component: cCertificate,
		  //     meta:{
		  //         hideNav:false,
		  //         index:9,
		  //         name:'发证记录',
		  //         role: ['company']
		  //     }
		  // },
		  // {
		  //     path: 'certificate_list',
		  //     name:'companyCertificateList',
		  //     component: cCertificateList,
		  //     meta:{
		  //         hideNav:false,
		  //         index:10,
		  //         name:'证书管理',
		  //         role: ['company']
		  //     }
		  // },
		  
    //       ],
    //   },
        {
            path: '/course_preview/:id',
            name: 'coursePreview',
            component: CoursePreview,
            meta: {
                name:'课程预览'
            },
        },
        {
            path: '/article_preview/:id',
            name:'article_preview',
            component: ArticlePreview,
            meta:{
                 name:'文章预览'
            }
        },
        // {
        //     path: '/login',
        //     name: 'login',
        //     component: Login,
        //     meta: {
        //         name:'登录'
        //     },
        // },
        // {
        //     path: '/reg',
        //     name: 'reg',
        //     component: Reg,
        //     meta: {
        //         name:'注册协议'
        //     },
        // },
        // {
        //     path: '/reg2',
        //     name: 'reg2',
        //     component: Reg2,
        //     meta: {
        //     name:'用户基本信息',
        // },
        // },
        // {
        //     path: '/reg3/:type',
        //     name: 'reg3',
        //     component: Reg3,
        //     meta: {
        //         name:'完善注册信息'
        //     },
        // },
        // {
        //     path: '/reg4',
        //     name: 'reg4',
        //     component: Reg4,
        //     meta: {
        //         name:'提交审核成功'
        //     },
        // },
        // {
        //     path: '/forget',
        //     name: 'forget',
        //     component: Forget,
        //     meta: {
        //         name:'提交审核成功'
        //     },
        // },
        {
            path: '*',
            redirect: '/index'
        }
    ]
})
